module.exports = __webpack_public_path__ + "media/ping.34bd4269.mp4";